module.exports = __webpack_public_path__ + "img/lenggan.9c8cfa2b.jpg";